module.exports = __webpack_public_path__ + "media/customizations/anthemmr/logo-new-2049df565c451d63e702668a95402971.png";